import { type RepubIs } from '@cx-web/utils';
import { useCmpProps } from '@cx-web/utils/cmp';

import FooterOC from '~/components/FooterOC';
import FooterWS from '~/components/FooterWS';
import { useUIConfig } from '~/providers/ui-config-context';
import { CxFooter } from '~/vendor/cx-web/components/composites/cx-footer/CxFooter';

import styles from './styles/Footer.module.scss';

export type FooterProps = {
  repubIs: RepubIs;
  resourcesUrl: string;
};

export default function Footer({ repubIs, resourcesUrl }: FooterProps) {
  const { isAdmiralCookieBannerEnabled } = useUIConfig();
  const cmpProps = useCmpProps();

  const renderProductPlusFooter = () => {
    if (repubIs.WS) {
      return <FooterWS resourcesUrl={resourcesUrl} />;
    }

    if (repubIs.OC) {
      return <FooterOC />;
    }

    if (repubIs.GZ) {
      return null;
    }

    return (
      <CxFooter
        cmpProps={cmpProps}
        isAdmiralCookieBannerEnabled={isAdmiralCookieBannerEnabled}
        resourcesUrl={resourcesUrl}
      />
    );
  };

  return (
    <footer className={styles.footer} id="mainAppFooter">
      {renderProductPlusFooter()}
    </footer>
  );
}
